export default __webpack_public_path__ + "static/media/ecc-loading.72a5db13.gif";